import React from "react";
import { TypeIcon } from "./typeIcon";
import styles from "./styles.module.css";
import { useDragOver } from "@minoru/react-dnd-treeview";
import Checkbox from "@mui/material/Checkbox";
import { useMediaQuery, useTheme } from "@mui/material";
import { useLocation } from "react-router-dom";

export const CustomNode = (props) => {
  const { droppable, data } = props.node;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const indent = props.depth * 24;
  const location = useLocation();

  const handleToggle = (e) => {
    e.stopPropagation();
    props.onToggle(props.node.id);
  };

  const handleSelect = (e) => {
    props.onSelect(e.shiftKey, props.node);
  };

  const handleSelectMouseDown = (e) => {
    props.onSelectMouseDown(e.shiftKey, props.node);
  };

  const handleCustomerClick = (e, node) => {
    if (node.partyId === props.preSelectedCustomer) {
    } else {
      if (props.screen === "products" || props.screen === "createOffering") {
        if (
          props.subScreen &&
          (props.subScreen === "productsFilter" ||
            props.subScreen === "product" ||
            props.subScreen === "oldOfferingFilter")
        ) {
          props.selectCustomers(node);
        } else {
          props.selectCustomers(node.partyId);
        }
      } else {
        handleSelect(e);
      }
    }
  };

  const dragOverProps = useDragOver(
    props.node.id,
    props.isOpen,
    props.onToggle,
  );

  const getSelectedCustomer = (id) => {
    var index = -1;
    if (props.screen === "products" && props.subScreen === "product") {
      index = props.customerData.findIndex((x) => x === id);
    } else {
      index = props.customerData.findIndex((x) => x.partyId === id);
    }
    if (index > -1) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div
      className={`tree-node ${styles.customNodeRoot} ${
        props.isSelected ? styles.isSelected : ""
      }`}
      style={{
        paddingInlineStart: indent,
        display: "flex",
        alignItems: "center",
      }}
      onClick={(e) => {
        if (props.offeringState !== "Published") {
          handleCustomerClick(e, props.node);
          if (props.isMobile) props.toggleShowCustomerList();
        }
      }}
      onMouseDown={handleSelectMouseDown}
      {...dragOverProps}
    >
      <div
        className={`${styles.expandIconWrapper} ${
          props.node.hasChildren && props.isOpen ? styles.isOpen : ""
        }`}
      >
        {props.node.hasChildren && props.hierarchyLevel !== 1 ? (
          <div onClick={handleToggle}>
            <OpenItemIcon />
          </div>
        ) : (
          <EndItemIcon />
        )}
      </div>
      <div>
        {/* <TypeIcon droppable={droppable} fileType={data?.fileType} /> */}
        <TypeIcon
          droppable={droppable}
          isManaged={props.node.isManaged}
          hasChildren={props.node.hasChildren}
          group={props.node.isGroup}
          level={props.node.level}
          username={props.node.username}
          partyType={props.node.partyType}
          hierarchyLevel={props.hierarchyLevel}
        />
      </div>
      <div
        className={styles.labelGridItem}
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "nowrap",
        }}
      >
        {(props.subScreen && props.subScreen === "productsFilter") ||
        (props.screen === "products" && props.subScreen === "product") ? (
          <span
            className={styles.labelGridItemName}
            style={{
              fontWeight: getSelectedCustomer(props.node.partyId)
                ? "bold"
                : "normal",
            }}
            title={props.node.accountName}
          >
            {props.node.accountName}{" "}
          </span>
        ) : (
          <span
            className={styles.labelGridItemName}
            title={props.node.accountName}
          >
            {props.node.accountName}{" "}
          </span>
        )}
        {props.node.isGroup &&
          props.screen === "manageCustomer" &&
          props.userPerms.includes("PARTYMGR_ADMIN") &&
          props.providerType === "SALES_CHNL_PROVIDER" &&
          location.pathname !== "/manageLeads" && (
            <span style={{ float: "right" }}>
              <AddItemIcon
                onClick={(e) => {
                  e.preventDefault();
                  props.addChildItem(e, props.node.partyId);
                }}
              />
            </span>
          )}

        {props.screen === "products" &&
          props.screen !== "createOffering" &&
          props.subScreen !== "oldOfferingFilter" && (
            <span style={{ float: "right" }}>
              {props.subScreen && props.subScreen === "productsFilter" ? (
                <Checkbox
                  checked={getSelectedCustomer(props.node.partyId)}
                  color="primary"
                />
              ) : (
                <Checkbox
                  checked={props.customerData.includes(props.node.partyId)}
                  color="primary"
                  disabled={props.offeringState === "Published"}
                />
              )}
            </span>
          )}
      </div>
    </div>
  );
};

const OpenItemIcon = (props) => {
  return (
    <svg
      width="10"
      height="18"
      viewBox="0 0 10 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 16.5858C0 17.4767 1.07714 17.9229 1.70711 17.2929L9.29289 9.70711C9.68342 9.31658 9.68342 8.68342 9.29289 8.29289L1.70711 0.707106C1.07714 0.0771408 0 0.523309 0 1.41421V16.5858Z"
        fill="#c4c4c4"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="5"
          y1="-1"
          x2="5"
          y2="19"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#979797" />
          <stop offset="1" stopColor="#979797" stopOpacity="0.78" />
        </linearGradient>
      </defs>
    </svg>
  );
};
const EndItemIcon = (props) => {
  return (
    <svg
      width="10"
      height="10"
      style={{ position: "relative", top: "-2px" }}
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0Z"
        fill="#C4C4C4"
      />
    </svg>
  );
};
const AddItemIcon = (props) => {
  return (
    <svg
      title={props.title}
      onClick={props.onClick}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="18" height="18" rx="5" fill="white" />
      <rect width="18" height="18" rx="5" fill="#c4c4c4" />
      <path
        d="M14.25 9.75H9.75V14.25H8.25V9.75H3.75V8.25H8.25V3.75H9.75V8.25H14.25V9.75Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint1_linear"
          x1="9"
          y1="0"
          x2="9"
          y2="18"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C4C4C4" />
          <stop offset="1" stopColor="#C4C4C4" stopOpacity="0.58" />
        </linearGradient>
      </defs>
    </svg>
  );
};
const CloseItemIcon = (props) => {
  return (
    <svg
      width="18"
      height="10"
      viewBox="0 0 18 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.41421 0C0.523308 0 0.0771427 1.07714 0.707108 1.70711L8.29289 9.29289C8.68342 9.68342 9.31658 9.68342 9.70711 9.29289L17.2929 1.70711C17.9229 1.07714 17.4767 0 16.5858 0L1.41421 0Z"
        fill="url(#paint2_linear)"
      />
      <defs>
        <linearGradient
          id="paint2_linear"
          x1="19"
          y1="5"
          x2="-1"
          y2="5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#979797" />
          <stop offset="1" stopColor="#979797" stopOpacity="0.78" />
        </linearGradient>
      </defs>
    </svg>
  );
};
